import { pluralizeWord } from '@doveit/hammer';
import { GoalMetric, PerformanceMetric, TimeRange } from '../../../../providers/api/dtos';
import { template } from '../../../../utils/text/text';
import { configByMetric } from './getPerformanceDescription';

export function getTargetDescription(
  {
    metric,
    metricData,
    salesProgress,
    timeRange,
  }: {
    metric: GoalMetric,
    metricData: Record<TimeRange, PerformanceMetric>,
    salesProgress: number,
    timeRange: TimeRange,
  },
) {
  const { label: { singular, plural, stem }, verb, frequency } = configByMetric[metric];
  const performanceMetric = metricData[timeRange];

  if (metricData.yearly.progress >= 1 || (salesProgress >= 1 && performanceMetric.status === 'ABOVE_EXPECTATIONS')) {
    return undefined;
  }

  return template('Per completare l\'obiettivo, dovrai ora {METRIC_VERB} {FORECAST} {METRIC_LABEL} {METRIC_FREQUENCY} da qui a fine anno.', {
    FORECAST: performanceMetric.forecast,
    METRIC_VERB: verb,
    METRIC_LABEL: pluralizeWord(stem, singular, plural, performanceMetric.forecast),
    METRIC_FREQUENCY: frequency,
  });
}
